var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3313_5375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 7.83203C13.7891 7.81738 13.9258 7.8125 14.0625 7.8125C16.6504 7.8125 18.75 9.86816 18.75 12.5C18.75 15.0879 16.6504 17.1875 14.0625 17.1875C11.4307 17.1875 9.375 15.0879 9.375 12.5C9.375 12.3633 9.37989 12.2266 9.39454 12.0898C9.84864 12.3096 10.376 12.5 10.9375 12.5C12.6611 12.5 14.0625 11.0986 14.0625 9.375C14.0625 8.81348 13.8721 8.28613 13.6523 7.83203ZM23.4668 5.49805C25.752 7.61719 27.2803 10.1123 28.0029 11.8994C28.1641 12.2852 28.1641 12.7148 28.0029 13.1006C27.2803 14.8437 25.752 17.3389 23.4668 19.502C21.167 21.6406 18.0078 23.4375 14.0625 23.4375C10.1172 23.4375 6.95801 21.6406 4.65918 19.502C2.37403 17.3389 0.846684 14.8437 0.12017 13.1006C0.0408429 12.9103 0 12.7062 0 12.5C0 12.2938 0.0408429 12.0897 0.12017 11.8994C0.846684 10.1123 2.37403 7.61719 4.65918 5.49805C6.95801 3.36133 10.1172 1.5625 14.0625 1.5625C18.0078 1.5625 21.167 3.36133 23.4668 5.49805ZM14.0625 5.46875C10.1807 5.46875 7.03125 8.61816 7.03125 12.5C7.03125 16.3818 10.1807 19.5312 14.0625 19.5312C17.9443 19.5312 21.0938 16.3818 21.0938 12.5C21.0938 8.61816 17.9443 5.46875 14.0625 5.46875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3313_5375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.125,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9777561f76ad43a2631651e477d62da2.svg";
export { ForwardRef as ReactComponent };